import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {CreateDocumentRequest} from '../models/documents/createDocument.request';
import {JobDeliveryNotes} from '../models/delivery.note/jobDeliveryNotes.model';
import {CreateDeliveryNoteRequest} from '../models/delivery.note/CreateDeliveryNote.request';
import {UpdateDeliveryNotesRequest} from '../models/delivery.note/UpdateDeliveryNotes.request';

@Injectable({
  providedIn: 'root'
})
export class DeliveryNoteService {

  constructor(private http: HttpClient) {
  }

  private BASE_SERVICE: string = environment.BASE_URL + 'job/';
  private DELIVERY_NOTE_SERVICE = '/delivery/note';

  public getDeliveryNotes(jobId: string): Observable<JobDeliveryNotes> {
    return this.http.get<JobDeliveryNotes>(`${this.BASE_SERVICE}${jobId}${this.DELIVERY_NOTE_SERVICE}`);
  }


  public createDeliveryNote(jobId: string, request: CreateDeliveryNoteRequest): Observable<JobDeliveryNotes> {
    return this.http.post<JobDeliveryNotes>(`${this.BASE_SERVICE}${jobId}${this.DELIVERY_NOTE_SERVICE}`, request);
  }

  public deleteDeliveryNote(jobId: string, id: string): Observable<JobDeliveryNotes>  {
    return this.http.delete<JobDeliveryNotes>(`${this.BASE_SERVICE}${jobId}${this.DELIVERY_NOTE_SERVICE}/${id}`);
  }

  public updateDeliveryNotes(jobId: string, request: UpdateDeliveryNotesRequest): Observable<JobDeliveryNotes>{
    return this.http.patch<JobDeliveryNotes>(`${this.BASE_SERVICE}${jobId}${this.DELIVERY_NOTE_SERVICE}`, request);
  }
}
